import { render, staticRenderFns } from "./AirplaneCrashList.vue?vue&type=template&id=d644a7d4&scoped=true"
import script from "./AirplaneCrashList.vue?vue&type=script&lang=js"
export * from "./AirplaneCrashList.vue?vue&type=script&lang=js"
import style0 from "./AirplaneCrashList.vue?vue&type=style&index=0&id=d644a7d4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d644a7d4",
  null
  
)

export default component.exports